<template>
<div class="related-info-container" v-if="!isEmpty(data)">
  <span class="title">연관 장비:</span>
  <el-tag v-for="(item, idx) in data" :key="idx" :type="item.type" effect="dark" @click="clickRelatedObj(item)">
    <div >{{ item }}</div>
  </el-tag>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WRelatedInfo',
  props: {
    data: {
      type: Array,
    },
  },
  methods: {
    isEmpty,
    clickRelatedObj(item) {
      this.$emit('search-related-obj', item);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/SearchResultView/RelatedInfo.vue